export const SELECT_DOCTOR_ID = "doctor_id";
export const LEAVE_START_DATE = "leave_start_date";
export const LEAVE_END_DATE = "leave_end_date";
export const FETCH_DOCTOR_LEAVES = "fetch_doctor_leaves";
export const DOCTOR_LEAVE_SUBMIT_FORM = "doctor_leave_submit";
export const DOCTOR_LEAVE_EDIT_SUBMIT_FORM = "doctor_leave_edit_submit_form";
export const DOCTOR_LEAVE_DELETE = "doctor_leave_delete";
export const FETCH_DOCTOR_LEAVES_SUCCESS = "fetch_doctor_leave_success";
export const DOCTOR_LEAVE_ACTION_SUCCESS = "doctor_leave_action_success";
export const DOCTOR_LEAVE_EDIT = "doctor_leave_edit";
export const DOCTOR_LEAVE_DIALOG_BOX_STATUS = "doctor_leave_dialog_box_status";
export const DOCTOR_LEAVE_SET_DELETE_ID = "doctor_leave_set_delete_id";
export const SELECT_REMARK = "doctor_leave_REMARK";
